module.exports = __webpack_public_path__ + "static/media/ChestFounder.fbd13e1e.png";